<template>
  <base-modal :box="box_init" :step="step">
    <z-form ref="form" @submit.native.prevent="save">
      <form-input-name v-model="form.name" :box_type="box.type" />
      <file-select-button
        :label="$t('pbx.worksheet.action.playback.input.media.label')"
        @on-browse="set_media_step"
      />
      <z-form-input :rules="{ required: true }" class="validator validator--media">
        <file-list v-model="form.params.media" />
      </z-form-input>
    </z-form>
    <i-button ref="close" slot="footer-cancel" slot-scope="{ close }" size="large" @click="close()">
      {{ $t('pbx.worksheet.modal.action.main.button.cancel') }}
    </i-button>
    <i-button
      slot="footer-ok"
      slot-scope="{ is_button_loading }"
      type="success"
      size="large"
      :loading="is_button_loading"
      @click="save"
    >
      {{ $t('pbx.worksheet.modal.action.main.button.ok') }}
    </i-button>
  </base-modal>
</template>
<script>
  import BaseModal from '../../../_base/index';
  import FormInputName from '../../../_base/_fragments/form-input-name';
  import FileSelectButton from '../../../_fragments/file-select-button/index';
  import FileList from '../../../_fragments/file-list/index';
  import { StepMixin } from '../../../_base/step-mixin';

  /**
   * props.box - автоматически прокидывается в form
   * чтобы сохранить состояние шага, используй mixin_save_step из StepMixin
   */

  export default {
    components: {
      BaseModal,
      FormInputName,
      FileSelectButton,
      FileList
    },
    mixins: [StepMixin],

    data() {
      return {
        files: []
      };
    },


    methods: {
      save: function () {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            const box = this.mixin_get_box(this.form);
            this.$emit('on-save', box);
          }
        });
      },

      set_media_step() {
        this.mixin_save_step(this.form);
        this.mixin_set_step('add-media');
      }
    }
  };
</script>

<style lang="scss">
  .validator--media {
    .form-input__error--absolute {
      top: -30px;
      left: 165px;
    }
  }
</style>
